<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '../components/page/table.vue'
    import FORM from '../components/page/form.vue'
    import UPDATE from '../components/page/update.vue'
    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    //00000000代表游客账号，也就是默认自选产品
    let defalutAccount = "00000000";
    let accountNoList = {"00000000":"默认","用户":"用户"};
    let platformList = {"GTS2": "GTS2", "MT5": "MT5"};
    let codeList = {};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        created(){
            this.$axios.post(URL.optional.getCountryDictParamList).then(res => {
                // console.log(res);
                for (let i in res.result) {
                    codeList[res.result[i].iCodeId] = res.result[i].symbol;
                }
                // console.log(codeList);
            })
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "update"){
                    this.$refs.childUpdate.open(row);
                }else if (clickName == "delete"){
                    this.dataChanage(URL.optional.delete,{id:row.id},res =>{
                        if (res.code == 0){
                            this.$message.success("suc");
                        }else{
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('mis.bt.search') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if(window.$t('mis.bt.add') == clickName){
                    this.$refs.childUpdate.open();
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model){
                model.symbol = codeList[model.iCodeId];
                if (!model.symbol) this.$message.error("iCodeId is null");
                //根据是否包含id更新还是添加
                this.dataChanage(URL.optional.edit,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[
                        { title: "id", field: 'id',hidden: true},
                        { title: window.$t('mis.optional.accountNo'), field: 'accountNo',data:defalutAccount, hidden: true,required:true},
                        { title: window.$t('mis.optional.symbol'), field: 'iCodeId',type:2,optionList:codeList,required:true},
                        { title: window.$t('mis.optional.platform'), field: 'platform',type:2,optionList:platformList,required:true},
                        { title: window.$t('mis.optional.channel'), field: 'channel',required:true},
                    ],
                },
                /*from查询表单*/
                formData:{
                  hasLable: true,
                  cols:[
                      { title: window.$t('mis.optional.account'), field: 'account',data:defalutAccount,type:2,optionList:accountNoList},
                      { title: window.$t('mis.optional.accountNo'), field: 'accountNo'},
                      { title: window.$t('mis.optional.platform'), field: 'platform',type:2,optionList:platformList},
                      { title: window.$t('mis.optional.channel'), field: 'channel'},
                      {click:window.$t('mis.bt.search')},
                      {click:window.$t('mis.bt.add')},
                  ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.optional.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        { title: window.$t('mis.optional.accountNo'), field: 'accountNo',render:(data,full)=> {
                                return data == defalutAccount?"默认":data;
                            }},
                        { title: window.$t('mis.optional.iCodeId'), field: 'iCodeId'},
                        { title: window.$t('mis.optional.symbol'), field: 'symbol'},
                        { title: window.$t('mis.optional.platform'), field: 'platform'},
                        { title: window.$t('mis.optional.channel'), field: 'channel'},
                        { title: window.$t('mis.optional.createTime'), field: 'createTime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                        {title:window.$t('mis.bt.operation'),btnClick:[
                                {name:window.$t('mis.bt.edit'),click:"update",type:"primary",icon: "el-icon-edit",hidden:(data,full)=>{
                                    return full.accountNo != defalutAccount;
                                    }},
                                {name:window.$t('mis.bt.delete'),click:"delete",type:"primary",icon:"el-icon-delete",hidden:(data,full)=>{
                                        return full.accountNo != defalutAccount;
                                    }}
                            ]
                        },
                    ]
                }
            }
        }
    }
</script>
